export default __webpack_public_path__ + "static/media/no-image.96bfff02.svg";